import { useContext } from 'react'

import { ServiceContext, useSelectedServiceFkey } from '~/contexts/Service'
import { UserContext } from '~/contexts/User'

interface WalkMeVariables {
  email?: string
  roles?: string[]
  serviceFkey: Nullable<string>
  serviceName?: string
  userFkey?: string
}

interface Props {
  children: JSX.Element
}

declare global {
  interface Window {
    walkMeVariables: WalkMeVariables
  }
}

const WalkMe = ({ children }: Props) => {
  const user = useContext(UserContext)
  const {
    state: { services },
  } = useContext(ServiceContext)
  const serviceFkey = useSelectedServiceFkey()
  const selectedService = services.find((service) => service.fkey === serviceFkey)

  window.walkMeVariables = {
    serviceFkey,
    userFkey: user.state?.fkey,
    roles: user.state?.roles,
    email: user.state?.email,
    serviceName: selectedService?.name,
  }

  return children
}

export default WalkMe
